import { Box, Typography } from "@mui/material";
import { BarChart, PieChart, ShowChart, Speed } from "@mui/icons-material";
import { CHART_TYPE_OPTIONS } from "./widgetBuilderConstants";

const ICONS: Record<string, React.ReactNode> = {
  BarChart: <BarChart />,
  PieChart: <PieChart />,
  ShowChart: <ShowChart />,
  Speed: <Speed />,
};

interface ChartTypePickerProps {
  value: string;
  onChange: (chartType: string) => void;
  allowedTypes: string[];
}

export default function ChartTypePicker({
  value,
  onChange,
  allowedTypes,
}: Readonly<ChartTypePickerProps>) {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      {CHART_TYPE_OPTIONS.map((option) => {
        const isSelected = value === option.value;
        const isDisabled = !allowedTypes.includes(option.value);

        return (
          <Box
            key={option.value}
            role="button"
            aria-pressed={isSelected}
            aria-disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) onChange(option.value);
            }}
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.5,
              p: 1.5,
              borderRadius: 1,
              border: 2,
              borderColor: isSelected ? "primary.main" : "divider",
              bgcolor: isSelected
                ? "primary.50"
                : isDisabled
                  ? "action.disabledBackground"
                  : "background.paper",
              opacity: isDisabled ? 0.4 : 1,
              cursor: isDisabled ? "default" : "pointer",
              transition: "all 0.15s",
              "&:hover": isDisabled
                ? {}
                : { borderColor: "primary.light" },
            }}
          >
            {ICONS[option.icon]}
            <Typography variant="caption" sx={{ fontWeight: isSelected ? 600 : 400 }}>
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
